import React, { useMemo, useState, useRef } from "react";
import { motion } from "framer-motion";
import SearchSelect from "../SearchSelect";
import { AccountAvatarIcon } from "../icons";
import { countries } from "../countries";
import { getBase64, imageCompressorFunc } from "../../utils";
import * as Yup from "yup";

export default function StepOne(props) {
  props.stepRef.validateData = validateData;
  const { selectedCountry, onSelectCountry, onInputChange, data } = props;
  const mappedCountries = useMemo(() => {
    const mapped = countries.map((ctr) => ({
      label: ctr.name,
      value: ctr.dial_code,
      labelformated: `(${ctr.dial_code}) ${ctr.name}`,
    }));
    return mapped;
  }, []);
  const [errors, setErrors] = useState([]);
  const [selectedImg, setSelectedImg] = useState(
    data.image ? data.image : null
  );

  const imageFileInput = useRef(null);
  async function handleFileUpload(e) {
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      const result = await imageCompressorFunc(files[i]);
      if (!result.ok) return;
      const bs = await getBase64(result.data);
      setSelectedImg({
        file: result.data,
        preview: bs,
      });
    }
  }
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const stepOneSchema = {
    firstName: Yup.string().required().label("First Name"),
    lastName: Yup.string().required().label("Last Name"),
    email: Yup.string().required().email().label("Email Address"),
    gender: Yup.string().required().label("Gender"),
    country: Yup.string().required().label("Country"),
    phoneNumber: Yup.string()
      .required()
      .matches(phoneRegExp, "Phone number must match somthing like 112344859")
      .min(9)
      .max(10)
      .label("Phone Number"),
  };
  const schema = Yup.object().shape(stepOneSchema);

  async function validateData() {
    const stepOneData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      gender: data.gender,
      phoneNumber: data.phoneNumber,
      country: selectedCountry?.value,
    };
    try {
      await schema.validate(stepOneData, {
        abortEarly: false,
      });
      if (selectedImg) {
        onInputChange("image", selectedImg);
      }
      return { ok: true };
    } catch (error) {
      const errorObject = {};
      error.inner.forEach((e) => {
        errorObject[e.path] = e.message;
      });
      setErrors(errorObject);
      return { ok: false };
    }
  }
  function handleClearError(property) {
    setErrors({ ...errors, [property]: "" });
  }
  function handleFormInput(label, value) {
    handleClearError(label);
    onInputChange(label, value);
  }
  const countrySearchSelect = useRef(null);
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="mb-5 text-center">
        <div className="mx-auto w-32 h-32 border rounded-full relative bg-gray-100 mb-4 shadow-inset overflow-hidden">
          {selectedImg ? (
            <div
              className="bg"
              style={{
                backgroundImage: `url('${selectedImg.preview}')`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "auto",
                height: "100%",
              }}
            ></div>
          ) : (
            <AccountAvatarIcon iconClasses="h-32 w-32 text-gray-300 rounded-full" />
          )}
        </div>

        <label
          onClick={() => imageFileInput.current.click()}
          type="button"
          className="cursor-pointer inine-flex justify-between items-center focus:outline-none border py-2 px-4 rounded-lg shadow-sm text-left text-gray-600 bg-white hover:bg-gray-100 font-medium"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="inline-flex flex-shrink-0 w-6 h-6 -mt-1 mr-1"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
            <path d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
            <circle cx="12" cy="13" r="3" />
          </svg>
          Browse Photo
        </label>

        <div className="mx-auto w-48 text-gray-500 text-xs text-center mt-1">
          Click to add profile picture
        </div>

        <input
          name="photo"
          ref={imageFileInput}
          onChange={handleFileUpload}
          accept="image/*"
          className="hidden"
          type="file"
        />
      </div>
      <div className="grid gap-2 grid-cols-1 md:grid-cols-2">
        <div className="mb-5">
          <label
            htmlFor="firstName"
            className="font-semibold mb-1 text-theme block"
          >
            First Name
          </label>
          <input
            type="text"
            value={data.firstName}
            onChange={(e) => handleFormInput("firstName", e.target.value)}
            className={`${
              errors.firstName ? "border-red-500" : "border-gray-200"
            } border rounded py-2 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black `}
            placeholder="Enter your firstname..."
          />
          {errors.firstName ? (
            <small className="px-2 text-red-500 text-xs">
              {errors.firstName}
            </small>
          ) : null}
        </div>
        <div className="mb-5">
          <label
            htmlFor="lastName"
            className="font-semibold mb-1 text-theme block"
          >
            Last Name
          </label>
          <input
            type="text"
            value={data.lastName}
            onChange={(e) => handleFormInput("lastName", e.target.value)}
            className={`${
              errors.lastName ? "border-red-500" : "border-gray-200"
            } border rounded py-2 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black `}
            placeholder="Enter your lastname..."
          />
          {errors.lastName ? (
            <small className="px-2 text-red-500 text-xs">
              {errors.lastName}
            </small>
          ) : null}
        </div>
      </div>

      <div className="mb-5">
        <label htmlFor="email" className="font-semibold mb-1 text-theme block">
          Email
        </label>
        <input
          type="email"
          value={data.email}
          onChange={(e) => handleFormInput("email", e.target.value)}
          className={`${
            errors.email ? "border-red-500" : "border-gray-200"
          } border rounded py-2 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black `}
          placeholder="Enter your email address..."
        />
        {errors.email ? (
          <small className="px-2 text-red-500 text-xs">{errors.email}</small>
        ) : null}
      </div>
      <div className="mb-5">
        <label htmlFor="phoneNumber" className="font-semibold text-theme block">
          Phone Number
        </label>
        <SearchSelect
          listOfValues={mappedCountries}
          setSelectedValue={onSelectCountry}
          searchSelectRef={countrySearchSelect}
          defaultValue={selectedCountry ? selectedCountry.label : ""}
        />
        {errors.country ? (
          <small className="px-2 text-red-500 text-xs">{errors.country}</small>
        ) : null}
        {selectedCountry && selectedCountry.label && (
          <div className="w-full  svelte-1l8159u">
            <div className="my-2 bg-opacity-0 bg-black p-1 flex border border-gray-200 rounded svelte-1l8159u">
              <div className="flex flex-auto flex-wrap"></div>
              <div className="text-theme py-1 pl-2 pr-1 border-r flex items-center border-gray-200 svelte-1l8159u">
                <p>{selectedCountry?.value}</p>
              </div>
              <input
                autoComplete="new-input"
                type="number"
                placeholder="7896..."
                value={data.phoneNumber}
                // value={value}
                onChange={(e) => handleFormInput("phoneNumber", e.target.value)}
                className={`${
                  errors.phoneNumber ? "border-red-500" : "border-gray-200"
                } border rounded py-2 px-2 appearance-none outline-none w-full text-theme  svelte-1l8159u bg-opacity-0 bg-black `}
              />
            </div>
            {errors.phoneNumber ? (
              <small className="px-2 text-red-500 text-xs">
                {errors.phoneNumber}
              </small>
            ) : null}
          </div>
        )}
      </div>
      <div className="mb-5">
        <label htmlFor="email" className="font-bold mb-1 text-theme block">
          Gender
        </label>

        <div className="flex justify-around">
          <label className="flex justify-start items-center text-truncate rounded-lg bg-white pl-4 pr-6 py-3 shadow-sm mr-4">
            <div className="text-theme  mr-3">
              <input
                type="radio"
                value="Male"
                name="gender"
                onChange={(e) => handleFormInput("gender", e.target.value)}
                className="form-radio focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="select-none text-theme">Male</div>
          </label>

          <label className="flex justify-start items-center text-truncate rounded-lg bg-white pl-4 pr-6 py-3 shadow-sm">
            <div className="text-theme mr-3">
              <input
                type="radio"
                value="Female"
                name="gender"
                onChange={(e) => handleFormInput("gender", e.target.value)}
                className="form-radio focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="select-none text-theme">Female</div>
          </label>
          <label className="flex justify-start items-center text-truncate rounded-lg bg-white pl-4 pr-6 py-3 shadow-sm">
            <div className="text-theme mr-3">
              <input
                type="radio"
                value="Other"
                name="gender"
                onChange={(e) => handleFormInput("gender", e.target.value)}
                className="form-radio focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="select-none text-theme">Other</div>
          </label>
        </div>
        {errors.gender ? (
          <small className="px-2 text-red-500 text-xs">{errors.gender}</small>
        ) : null}
      </div>
    </motion.div>
  );
}
